import { useEffect, useState } from 'react';
import { useAuthStore } from '../../../common/hooks/useAuthStore';
import { useConfig } from '../../../providers/config-provider';
import { useContent } from '../../../providers/content/hook';
import { useDevice } from '../../../providers/device-provider';
import RegionProvider from '../../../providers/region-provider';
import { UserProfileProps, useUserProfile } from '../../../providers/user-provider';
import { getTextFromHtml } from '../../../utils/common';
import { safeGet } from '../../../utils/objectUtils';
import { getRegionFromPath, getRegionsFromHeaderContent } from '../../../utils/regionUtils';
import PopUpNotification from '../../basic/popupNotification';
import { IHeaderProps } from './IHeader';
import DesktopNavbar from './desktop/desktop-navbar';
import MobileNavbar from './mobile/mobile-navbar';
import { PERSONALIZED_ALERT_AUTO_OPEN_KEY } from '../../../utils/sessionStorageUtils';

export default function Header({ headerProps }: { headerProps: IHeaderProps }): JSX.Element {
  const { content } = useContent();
  const { userProfile } = useUserProfile();
  const { config } = useConfig();
  const [selectedRegion, setSelectedRegion] = useState({ key: '', value: '' });
  const [showRegionChangedPopUp, setShowRegionChangedPopUp] = useState(false);
  const { isMobile } = useDevice();
  const authStore = useAuthStore();
  const regions = getRegionsFromHeaderContent(content);
  const regionPath = getRegionFromPath();


  useEffect(() => {
    // const regions = safeGet(content, 'header.regions.value', []);
    if (!userProfile?.region) {
      // For Not logged in users
      const mappingRules = safeGet(config, 'rules.mappingRules', null);
      const mappedRegion = mappingRules?.find((rule: any) => rule?.path?.split('/')[1] === regionPath);
      const isRegionChanged = (region: string, userRegion: string) => {
        return region?.toLowerCase() === userRegion?.toLowerCase();
      }
      const userRegion = regions?.find((reg: { key: string }) => {
        return isRegionChanged(reg?.key, mappedRegion?.regionCode || '');
      });
      setSelectedRegion(userRegion);
    } else {
      const region = regions.find((item: any) => userProfile.region.toUpperCase() === item.key.toUpperCase())
      setSelectedRegion(region);
    }
  }, [userProfile?.region, regions]);

  useEffect(() => {
    if (authStore.isRegionChanged) {
      sessionStorage.setItem(PERSONALIZED_ALERT_AUTO_OPEN_KEY, 'true');
      setShowRegionChangedPopUp(true)
    }
  }, [authStore?.isRegionChanged])

  if (!headerProps) return <></>

  const notificationTitle = headerProps?.regionMessages?.region_change_notification_hdr;
  const notificationMessage = headerProps?.regionMessages?.region_change_notification_msg;

  function handleCloseRegionChangedDialog() {
    setShowRegionChangedPopUp(false)
    authStore.setIsRegionChanged(false)
  }
  return (
    <RegionProvider value={{ selectedRegion, setSelectedRegion: setSelectedRegion as any }}>
      <>
        {isMobile ? (
          <MobileNavbar headerProps={headerProps} />
        ) : (
          <DesktopNavbar headerProps={headerProps} />
        )}
        <PopUpNotification
          isMobile={isMobile}
          showPopUp={showRegionChangedPopUp}
          title={getTextFromHtml(notificationTitle)}
          desc={getTextFromHtml(notificationMessage)}
          onClose={handleCloseRegionChangedDialog}
        />
      </>
    </RegionProvider>
  );
}
